import { render, staticRenderFns } from "./AddPolygon.vue?vue&type=template&id=46cf8020"
import script from "./AddPolygon.vue?vue&type=script&lang=js"
export * from "./AddPolygon.vue?vue&type=script&lang=js"
import style0 from "./AddPolygon.vue?vue&type=style&index=0&id=46cf8020&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports